import React from "react";
import ReactDOM from "react-dom";

import "./index.css"; // Your global styles, if any
import App from "./App";
import { ContextProvider } from "./contexts/ContextProvider";

ReactDOM.render(
  <React.StrictMode>
    <ContextProvider>
      <App />
    </ContextProvider>
  </React.StrictMode>,

  document.getElementById("root")
);
